import ProgramApplicantDetailsContainer from './program_applicant_details_container';

const ProgramApplicantDetails = ProgramApplicantDetailsContainer;
export default ProgramApplicantDetails;
